import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white pt-28">
            <div className="max-w-4xl mx-auto px-6 md:px-8 py-16">
                {/* Back Link */}
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[#009B8F] hover:text-[#007d72] transition-colors mb-8 font-medium"
                >
                    <ArrowLeft size={18} />
                    Back to Home
                </Link>

                {/* Header */}
                <div className="mb-12">
                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#00151a] mb-4">
                        Cookie Policy
                    </h1>
                    <p className="text-slate-500 text-sm">Last updated: 1st March 2026</p>
                </div>

                {/* Content */}
                <div className="prose prose-slate max-w-none">
                    <div className="space-y-6 text-slate-700 leading-relaxed">
                        <p>
                            This Cookie Policy explains how Nex Overseas Ltd uses cookies and similar technologies on our website. Cookies are small text files stored on your device when you visit our platform. They help us improve how the website works, understand how users interact with our services, and provide a smoother and more personalised experience. By using our website, you agree to the use of cookies as described in this Policy.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">How We Use Cookies</h2>
                        <p>
                            We use cookies across all areas of our platform, including education consultancy, coaching and training, accommodation support, travel assistance, and our solicitor‑connection service. Some cookies are essential and allow the website to function properly. These include cookies that enable login, account security, and basic platform features. Without these cookies, certain parts of the website may not work.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Types of Cookies</h2>
                        <p>
                            We also use performance and analytics cookies to understand how visitors use our website. These cookies help us analyse traffic, identify issues, improve speed, and enhance the overall user experience. Functional cookies allow us to remember your preferences, such as language settings or saved progress, so you do not need to re‑enter information each time you visit. We may also use marketing or third‑party cookies to understand user interests and measure the effectiveness of our communications. We do not sell your data, and marketing cookies are only used with your consent.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Third-Party Cookies</h2>
                        <p>
                            Some cookies may be placed by third‑party services we use, such as payment providers, analytics tools, security systems, or email platforms. These providers follow strict data protection standards. You can control cookies through your browser settings, although disabling essential cookies may affect how the website functions. When you first visit our website, you can choose to accept all cookies, reject non‑essential cookies, or customise your preferences. You can change your cookie choices at any time.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Cookie Duration</h2>
                        <p>
                            Cookies may be session‑based, meaning they are deleted when you close your browser, or persistent, meaning they remain on your device for a set period. We only keep cookies for as long as necessary to fulfil their purpose. We may update this Cookie Policy from time to time, and any important changes will be communicated on our website.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Contact Us</h2>
                        <p>
                            If you have any questions about this Policy, you can contact us at <a href="mailto:info@nexoverseas.co.uk" className="text-[#009B8F] hover:underline">info@nexoverseas.co.uk</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookiePolicy;
